import { useState } from "react";
import SecBTN from "../../UI/SecBTN";
import TableRows from "./TableRows";
import classes from './AddDeleteTableRows.module.css'

function AddDeleteTableRows() {
  const [rowsData, setRowsData] = useState([]);

  const addTableRows = () => {
    const rowsInput = {
      subject:'',
      section:'',
      type:'',
      totalQuestion:'',
      positiveMarks:'',
      negativeMarks:'',
      partialMarks:'',
      addImage:'',
    };
    setRowsData([...rowsData, rowsInput]);
  };
  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  };
  return (
    <>
    <div className="text-end">
        <SecBTN className={classes["add-row"]} onClick={addTableRows}>Add New Row</SecBTN>
    </div>
    <div className={`table-responsive ${classes.table}`}>
    <table className="table table-bordered align-middle">
      <thead>
        <tr>
          <th>Subject</th>
          <th>Section</th>
          <th>Type</th>
          <th>No. Of Questions</th>
          <th>+ve Marks</th>
          <th>-ve Marks</th>
          <th>Partial Marks</th>
          <th>Add Image</th>
          <th>Delete Row</th>
        </tr>
      </thead>
      <tbody>
        <TableRows
          rowsData={rowsData}
          deleteTableRows={deleteTableRows}
          handleChange={handleChange}
        />
      </tbody>
    </table>
    </div>
    </>
  );
}
export default AddDeleteTableRows;
